import { TABLE_TABS_ENUM, TTableFiltersState } from "./types";

export const TABLE_FILTERS_SLICE_NAME = "tableFilters";

export const INITIAL_STORE: TTableFiltersState = {
  [TABLE_TABS_ENUM.ACTIVE_MARKET_AREAS]: {
    filters: { sortField: null, sortOrder: null },
  },
  [TABLE_TABS_ENUM.ARCHIVE_MARKET_AREAS]: {
    filters: { sortField: null, sortOrder: null },
  },
};
